/* MARVI OCEAN - Four4Luck values check.
   Same ethic as the honest question above it: no wrong answer, no lecture.
   Both replies take the person's view seriously instead of correcting it. */
(function(){
'use strict';
function boot(){
  var quizChoices = document.getElementById('f4lQuizChoices');
  var quizAnswer  = document.getElementById('f4lQuizAnswer');
  var quizAnswerTxt = document.getElementById('f4lQuizAnswerText');
  if(!quizChoices || !quizAnswer || !quizAnswerTxt) return;

  var REPLIES = {
    agree: 'Fair. One person genuinely can\u2019t fix an ocean. We don\u2019t claim otherwise \u2014 we just think something is still better than nothing, even when it\u2019s small.',
    disagree: 'That\u2019s the whole idea behind this page. Not because four pieces changes much on its own \u2014 because doing something, on purpose, changes you.'
  };

  var btns = quizChoices.querySelectorAll('[data-quiz]');
  for(var i=0;i<btns.length;i++){
    btns[i].addEventListener('click', function(){
      var c = this.getAttribute('data-quiz');
      quizAnswerTxt.textContent = REPLIES[c] || '';
      quizChoices.hidden = true;
      quizAnswer.hidden = false;
      quizAnswer.scrollIntoView({behavior:'smooth', block:'center'});
    });
  }
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
else boot();
})();
